// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var CreditNoteTemplateController = function ($scope, DocumentTemplate, NumberSequence, SupportedHtmlTagsDescription) {
    NumberSequence.getDocumentCounterSequences().then(function (data) { $scope.sequences = data; });

    DocumentTemplate.query({ documentType: 'CreditNote' }, function (data) { $scope.template = data[0]; });

    $scope.save = function () {
        if ($scope.template.Id && $scope.template.Id != "000000000000000000000000")
            $scope.template.$update({ documentType: $scope.template.DocumentType, id: $scope.template.Id }, function () {
                $scope.notifySuccess();
            });
        else
            $scope.template.$save(function () {
                $scope.notifySuccess();
            });
    };

    $scope.generalPlaceholders = ['FirstName', 'LastName', 'CompanyName', 'EmailAddress', 'Customer.ExternalId',
        'ReferenceCode', 'DebitorAccount', 'DueDate', 'Customer.CustomFields.****', 'Contract.CustomFields.****',
        'Contract.ExternalId', 'DocumentNumber', 'Balance', 'Currency'];

    $scope.merchantPlaceholders = ['Merchant.CreditorId', 'Merchant.CompanyName', 'Merchant.AddressLine1',
        'Merchant.AddressLine2', 'Merchant.StreetAddress', 'Merchant.HouseNumber', 'Merchant.ZIP', 'Merchant.City',
        'Merchant.Country', 'Merchant.Phone', 'Merchant.Website', 'Merchant.IBAN', 'Merchant.BIC', 'Merchant.EmailAddress'];

    SupportedHtmlTagsDescription.get().then(function (text) { $scope.popoverText = text; });
};
CreditNoteTemplateController.$inject = ['$scope', 'DocumentTemplate', 'NumberSequence', 'SupportedHtmlTagsDescription'];
